// extracted by mini-css-extract-plugin
export default {"Table":"table_Table__x0lBv","Table__text":"table_Table__text__yj0jL"};